export const GA_ID = 'G-SNZ5C7CHK8';
const KEY = 'pinveo_cookie_consent';
export type Consent = 'granted' | 'denied';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export function getConsent(): Consent | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'granted' || v === 'denied' ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(v: Consent) {
  try {
    localStorage.setItem(KEY, v);
  } catch {
    /* ignore */
  }
}

/**
 * Consent Mode v2 — tag gtag.js jest ZAWSZE w `index.html` (z domyślną zgodą
 * `denied`, więc bez cookies/danych do czasu zgody — RODO). Ta funkcja jedynie
 * aktualizuje stan zgody na analitykę. Dzięki temu tag jest wykrywalny przez
 * Google, a dane lecą dopiero po „Akceptuję".
 *
 * Uwaga: `trackPageview` wysyła page_view tylko gdy consent === 'granted';
 * przy denied/null jest no-op — cookieless pingi Consent Mode są blokowane.
 */
export function updateGaConsent(granted: boolean) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    analytics_storage: granted ? 'granted' : 'denied',
  });
}

/**
 * Wysyła page_view TYLKO gdy użytkownik udzielił zgody (consent === 'granted').
 * Przy braku zgody lub consent === 'denied' — no-op (RODO-strict).
 */
export function trackPageview(path: string) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  if (getConsent() !== 'granted') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
  });
}
